import { c as _c } from "react/compiler-runtime";
import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import type { BusinessInsightSubsection } from '../../onboarding-data.types';
import DecryptedContent from './components/decrypted-content';
type OnboardingBusinessInsightProps = {
  selectedSubsection: BusinessInsightSubsection;
  onboarding: EntityOnboarding;
};

/** The body of one subsection's `Card.Root`, which the caller titles. Expects the onboarding's vault to be decrypted already. */
const OnboardingBusinessInsight = t0 => {
  const $ = _c(3);
  const {
    selectedSubsection,
    onboarding
  } = t0;
  let t1;
  if ($[0] !== onboarding.id || $[1] !== selectedSubsection) {
    t1 = <DecryptedContent onboardingId={onboarding.id} selectedSubsection={selectedSubsection} />;
    $[0] = onboarding.id;
    $[1] = selectedSubsection;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default OnboardingBusinessInsight;